import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import styled from 'styled-components'
import { useNavigate, useLocation } from 'react-router-dom'

// globals
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'

// components
import PasswordComp from '../../components/signin/Password'
import Verification from '../../components/signin/Verification'
import ChkBox from '../../components/atom/checkBox/ChkBox'

// images
import Logo from '../../assets/image/logo/ic-logo-ho.svg'

// utils
import { useAxios } from '../../utils/useAxios'
import colors from '../../styles/colors'

export const SignIn = () => {
  const location = useLocation()
  const [saveUserId, setSaveUserId] = useState(localStorage.getItem('user_id') !== null)
  const [password, setPassword] = useState('')
  const [userId, setUserId] = useState('')
  const [minutes, setMinutes] = useState(undefined)
  const [seconds, setSeconds] = useState(undefined)
  const [clientMsg, setClientMsg] = useState('')
  const [certificationId, setCertificationId] = useState()
  const [isVerification, setIsVerification] = useState(false)
  const [isTimesUp, setIsTimesUp] = useState(false)
  const [verificationCode, setVerificationCode] = useState('')

  const navigate = useNavigate()
  const { fetchData, loading, data, error } = useAxios()

  // 아이디 저장
  useEffect(() => {
    document.getElementById('termChk').style.display = 'none'
  }, [])

  //
  useEffect(() => {
    if (location?.state?.selectedUserId) {
      setUserId(location?.state?.selectedUserId)
    } else if (localStorage.getItem('user_id') != null || undefined) {
      setUserId(JSON.parse(localStorage.getItem('user_id')))
    }
  }, [])

  // 필수 체크
  const userIdValidate = () => {
    //아이디 체크
    if (userId == '') {
      setClientMsg('아이디를 입력해주세요.')
      return false
    }

    //비밀번호 체크
    if (password == '') {
      setClientMsg('비밀번호를 입력해주세요.')
      return false
    }
  }

  const handleVerificationResponse = (response) => {
    if (response) {
      if (response.responseCode == TYPE.API_RESPONSE.SUCCESS) {
        if (saveUserId && response.responseData?.loginInfo) {
          localStorage.setItem(
            'user_id',
            JSON.stringify(response.responseData.loginInfo.userId),
          )
        } else if (!saveUserId) {
          localStorage.removeItem('user_id')
        }
      }
    }
  }

  // 아이디 저장
  const handleSaveUserId = () => {
    setSaveUserId(!saveUserId)
  }

  // 에러 처리
  useEffect(() => {
    if (error?.resultCode == 400) {
      setClientMsg('회원 아이디 또는 비밀번호가 일치하지 않습니다.')
    }
  }, [error])

  useEffect(() => {
    // 응답 성공(인증번호 확인)
    if (data) {
      switch (data.responseCode) {
        case TYPE.API_RESPONSE.SUCCESS: // 성공
          setCertificationId(data.responseData.certificationId)
          setVerificationCode(data.responseData.certificationCode)
          setIsVerification(true)
          document.getElementById('userId').setAttribute('disabled', '')
          document.getElementById('password').setAttribute('disabled', '')
          document.getElementById('wrapper').style.minHeight = '649px'
          setClientMsg('')
          setMinutes(5)
          setSeconds(0)
          return

        case TYPE.API_RESPONSE.MEMBER_9992: // 계정을 찾을 수 없습니다.
          setClientMsg('')
          alert('계정을 찾을 수 없습니다.')
          return

        case TYPE.API_RESPONSE.MEMBER_9993: // 해지된 사용자
          setClientMsg('')
          alert('해지된 사용자입니다.')
          return

        case TYPE.API_RESPONSE.MEMBER_9994: // 등록된 연락처 정보가 없습니다.
          setClientMsg('')
          alert('등록된 연락처 정보가 없습니다.')
          return

        case TYPE.API_RESPONSE.MEMBER_9995: // 비밀번호 오류횟수 초과
          alert('비밀번호 오류횟수 초과. 비밀번호 초기화 해주세요.')
          navigate('/changePassword') //old: resetPassword
          return

        case TYPE.API_RESPONSE.MEMBER_9996: // 장기 미접속 계정잠금상태입니다.
          navigate('/resetPassword', {
            state: {
              loginId: userId,
            },
          })
          return

        case TYPE.API_RESPONSE.MEMBER_9998: // 만료된 비밀번호
          navigate('/resetPassword?issue=inactive', {
            state: {
              loginId: userId,
            },
          })
          return

        case TYPE.API_RESPONSE.MEMBER_9999: // 실패
          setClientMsg('회원 아이디 또는 비밀번호가 일치하지 않습니다.')
          return

        default:
          return null
      }
    }
  }, [data])

  // 로그인(인증번호 요청)
  const signIn = async (e) => {
    e.preventDefault()

    if (userIdValidate() == false) return false

    const requestBody = {
      loginId: userId,
      password: password,
      // ip: ipAddress,
    }

    // 로그인 인증번호 발송 /loginCertification
    const params = {}
    fetchData(
      constants.API.LOGIN_CERTIFICATION, // url
      'POST', // method
      requestBody, // data
      params,
    )
  }

  // 인증번호 입력창 표시 [isVerification]
  useEffect(() => {
    if (isVerification) {
      document.getElementById('sendVerfBttn').style.position = 'relative'
    }
  }, [isVerification])

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      signIn(e)
    }
  }

  return (
    <>
      <Container>
        <Wrapper id="wrapper">
          <ContentWrapper>
            <img src={Logo} className="" onClick={() => navigate('/signin')} />
            <TitleTextWrapper>
              <TitleText>해피오더 사장님</TitleText>
            </TitleTextWrapper>
            <Input
              type="text"
              placeholder="아이디"
              value={userId}
              id="userId"
              onChange={(e) => setUserId(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <Input
              type="password"
              placeholder="비밀번호"
              id="password"
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
            />

            <ClientMsgWrapper>{clientMsg}</ClientMsgWrapper>
            <SaveIdWrapper>
              <CheckBox
                id="termChk"
                className="chkBox"
                onChange={handleSaveUserId}
                checked={saveUserId}
              />
              <label htmlFor="termChk">아이디 저장</label>
            </SaveIdWrapper>

            {isVerification ? (
              <VerificationWrapper>
                <Verification
                  minutes={minutes}
                  setMinutes={setMinutes}
                  seconds={seconds}
                  setSeconds={setSeconds}
                  onResponse={handleVerificationResponse}
                  userId={userId}
                  password={password}
                  // ipAddress={ipAddress}
                  certificationId={certificationId}
                  setCertificationId={setCertificationId}
                  verificationCode={verificationCode}
                  setVerificationCode={setVerificationCode}
                />
              </VerificationWrapper>
            ) : (
              <>
                <Button id="btn-test" type="button" onClick={(e) => signIn(e)}>
                  <ButtonText>로그인</ButtonText>
                </Button>
                <OptionsWrapper>
                  <IdOption onClick={() => navigate('/findid')}>
                    아이디 찾기
                  </IdOption>
                  <PwdOption onClick={() => navigate('/changePassword')}>
                    비밀번호 초기화
                  </PwdOption>
                </OptionsWrapper>
              </>
            )}
            <TradeMarkWrapper>
              <TradeMarkText>
                Copyright ⓒ by SPC ALL RIGHTS RESERVED.
              </TradeMarkText>
            </TradeMarkWrapper>
          </ContentWrapper>
        </Wrapper>
      </Container>
    </>
  )
}
export default SignIn
const ContentWrapper = styled.div`
  position: relative;
  width: 100%;
`
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  margin: auto;
`
const ClientMsgWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  text-align: left;
  color: #d90000;
  padding: 5px 10px 15px;
  @media ${(props) => props.theme.tablet} {
    padding: 0px 0px 7px 7px;
  }
`
const Wrapper = styled.div`
  img {
    width: 129.3px;
    height: 50px;
    cursor: pointer;
  }
  width: 430px;
  min-height: 577px;
  border-radius: 15px;
  box-shadow: 0 3px 12px 0 rgba(102, 102, 102, 0.1);
  background-color: #fff;
  padding: 50px 30px 30px;
  display: flex;
  justify-content: center;
  color: #8a8a8a;
  text-align: center;
  position: relative;
  @media ${(props) => props.theme.tablet} {
    width: 430px;
  }
  @media ${(props) => props.theme.mobile} {
    width: 360px;
    min-height: 760px;
    padding: 50px 30px 20px;
    box-shadow: none;
  }
`
const TitleTextWrapper = styled.div`
  margin: 15px 0px 25px;
  @media ${(props) => props.theme.mobile} {
  }
`
const TitleText = styled.span`
  font-size: 25px;
  font-weight: bold;
  text-align: center;
  color: #00402e;
  @media ${(props) => props.theme.mobile} {
  }
`
const Input = styled.input`
  font-size: 14px;
  text-align: left;
  color: #a8a8a8;
  width: 360px;
  height: 50px;
  border-radius: 8px;
  border: solid 1px #e5e5e5;
  background-color: #fff;
  color: #8a8a8a;
  box-shadow: none !important;
  padding: 10px;
  margin-bottom: 10px;
  &:focus {
    outline: none !important;
  }
  @media ${(props) => props.theme.mobile} {
    width: 300px;
    margin-bottom: 12px;
    padding: 15px 20px 15px 20px;
  }
`
const CheckBox = styled(ChkBox)`
  width: 24px;
  height: 24px;
  border-radius: 5px;
  margin-right: 8px;
`
const Button = styled.button`
  width: 360px;
  height: 50px;
  position: absolute;
  bottom: 100px;
  border-radius: 8px;
  background-color: #00a61c;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0px 0px 0px;
  border: none;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #fff;

  @media ${(props) => props.theme.mobile} {
    width: 300px;
    /* padding: 13px 128px; */
    margin: auto;
    bottom: 170px;
  }
`
const ButtonText = styled.span`
  @media ${(props) => props.theme.mobile} {
  }
`

const OptionsWrapper = styled.div`
  bottom: 40px;
  position: absolute;
  width: 100%;
  margin: 10px 0px 20px 0px;
  padding: 0px;
  font-size: 14px;
  display: flex;
  text-align: right;
  color: #8a8a8a;
  @media ${(props) => props.theme.mobile} {
    bottom: 110px;
  }
`
const VerificationWrapper = styled.div`
  @media ${(props) => props.theme.mobile} {
    margin-top: 20px;
  }
`
const IdOption = styled.div`
  width: 50%;
  display: inline;
  text-align: right;
  padding-right: 10px;
  border-right: solid 1px gray;
  cursor: pointer;
  @media ${(props) => props.theme.mobile} {
    padding-right: 14px;
  }
`
const PwdOption = styled.div`
  width: 50%;
  display: inline;
  text-align: left;
  margin-left: 10px;
  cursor: pointer;
  @media ${(props) => props.theme.mobile} {
    margin-left: 8px;
  }
`
const SaveIdWrapper = styled.div`
  width: 360px;
  margin: auto;
  margin-bottom: 30px;
  display: flex;
  font-size: 16px;
  text-align: left;
  color: #8a8a8a;
  align-items: center;
  @media ${(props) => props.theme.tablet} {
    margin-bottom: 20px;
  }
  @media ${(props) => props.theme.mobile} {
    width: 300px;
    padding: 0px;
    margin: 0px;
  }
`
const TradeMarkWrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  @media ${(props) => props.theme.mobile} {
  }
`
const TradeMarkText = styled.span`
  font-size: 12px;
  color: #a8a8a8;
  @media ${(props) => props.theme.mobile} {
  }
`
